import React from 'react';
import { Icon } from './Icon.js';
export const IconChartBubbleChat = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 4V18H9L11.25 22H12.75L15 18H22V4H2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7 13L10.5 9.5L12 11L13.5 12.5L17 9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartBubbleChat.js.map